import React, { useState, useEffect } from "react";
import { getLunar } from 'chinese-lunar-calendar'
import dayjs from "dayjs";
import styles from  "./index.module.css";

function Clock() {
  const [time, setTime] = useState('');
  const [week,setWeek] = useState('');
  const [date,setDate]  = useState('');
  const [lunarName, setLunarName] = useState("");

  const getClickData = () =>{
    getTimeData();
    getWeekData();
    getDateData();
  }
  useEffect(() => {
    getClickData();
    const timer = setInterval(() =>{
      getClickData();
    },1000*60)
    return () =>{
      clearInterval(timer);
    }
  }, []);  // 依赖于时间的更新
  
  const getTimeData = () =>{
    const hours = dayjs().format("HH");
    const minutes = dayjs().format("mm");
    setTime(`${hours}:${minutes}`);
  }
  const getWeekData = () =>{
    const weekday = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
    const date = new Date();
    const dayOfWeek = weekday[date.getDay()];
    setWeek(dayOfWeek);
  }

  const getDateData = () => {
    const date = new Date();
    const year = date.getFullYear().toString(); // 获取当前年份并转为字符串
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 获取当前月份并转为字符串，不满两位数的月份在前补0
    const day = date.getDate().toString().padStart(2, '0'); // 获取当前日期并转为字符串，不满两位数的日期在前补0
    setDate(`${year}/${month}/${day}`);
    let data = getLunar(new Date().getFullYear(), (new Date().getMonth() + 1), new Date().getDate());
    console.log(data);
    setLunarName(data.dateStr);
  }
  
  return (
    <div className={styles['clock-container']}>
      <div className={styles['clock-time']}>
        {
          time
        }
      </div>
      <div className={styles['clock-date']} >
        <div className={styles['week']} >{week}</div>
        <div className={styles['date']} >{date}</div>
        <div className={styles['month']} >农历 {lunarName}</div>
      </div>
    </div>
  );
}

export default Clock;